import React from 'react'
import { Redirect, useLocation } from 'react-router-dom'
import { legacyQueryRedirectRules } from './paths'

export default function LegacyQueryRedirect({ queryKey, buildTarget }) {
  const location = useLocation()
  const search = new URLSearchParams(location.search)
  const entityId = search.get(queryKey)
  if (!entityId) return <Redirect to="/404" />
  const target = buildTarget(entityId)
  const preserved = new URLSearchParams(location.search)
  preserved.delete(queryKey)
  const suffix = preserved.toString()
  return <Redirect to={suffix ? `${target}?${suffix}` : target} />
}

export function LegacyQueryRedirectSwitch() {
  const location = useLocation()
  const rule = legacyQueryRedirectRules.find((item) => item.pathname === location.pathname)
  if (!rule) return null
  return <LegacyQueryRedirect pathname={rule.pathname} queryKey={rule.queryKey} buildTarget={rule.buildTarget} />
}
